import { lazy } from 'react';

/* 🔹 Lazy-loaded Coach Pages (MNC Standard) */
const CoachDashboard = lazy(() => import('../pages/coach/Dashboard'));
const Students = lazy(() => import('../pages/coach/Students'));
const SessionMaster = lazy(() => import('../pages/coach/SessionMaster'));
const SessionInfo = lazy(() => import('../pages/coach/SessionInfo'));
const SessionDetails = lazy(() => import('../pages/coach/SessionDetails'));
const Attendance = lazy(() => import('../pages/coach/Attendance'));
const DetailedAttendance = lazy(() => import('../pages/coach/DetailedAttendance'));

const Template = lazy(() => import('../pages/coach/Template'));

const coachRoutes = [
  { path: 'dashboard', element: <CoachDashboard /> },

  { path: 'students', element: <Students /> },

  { path: 'session-master', element: <SessionMaster /> },

  { path: 'attendance', element: <Attendance /> },

  { path: 'detailed-attendance', element: <DetailedAttendance /> },

  { path: 'session-info', element: <SessionInfo /> },

  { path: 'session-info/:id', element: <SessionDetails /> },

  { path: 'template', element: <Template /> },
];

export default coachRoutes;
